/**
 * Resolves the tab a tab-page should actually render. A deep link carries a
 * tab name in the URL, but a tab that is not visible for the current
 * permissions or entity state has no nav element and no panel to show;
 * rendering it verbatim leaves an empty content area. Falling back to the
 * page's default tab keeps the URL untouched, so the link starts working the
 * moment the visibility is regained.
 * @param requestedTab - The tab named by the URL.
 * @param tabVisibility - The page's single source of per-tab visibility.
 * @param fallbackTab - The page's default tab, which is always visible.
 * @returns `requestedTab` when it is visible, otherwise `fallbackTab`.
 */
export function resolveEffectiveTab<Tab extends string> (
    requestedTab: Tab,
    tabVisibility: Record<Tab, boolean>,
    fallbackTab: Tab
): Tab {
    return tabVisibility[requestedTab] ? requestedTab : fallbackTab;
}
